import React, { useState, useEffect } from "react";

/** Routing related */
import { Link,useParams } from 'react-router-dom'  

/** Bootstrap Components */
import { Card,Container,Row,Col } from 'react-bootstrap';  

/** React Icons */
import { MdArrowBack } from "react-icons/md";
import { FaExclamationTriangle } from "react-icons/fa";

/** Custom styles */
import '../css/styles.css';  

/** Custom Components */
import NavbarComponent from '../navbar';
import FooterComponent from '../footer';

import { APPROPRIATION_BY_DEMAND_URL } from '../utils/constants';


const AppropriationComponent = () => {
	let { id } = useParams();
	const [hasError, setErrors] = useState(false);
	const [items, setItems] = useState([]);
	const [isLoaded, setLoader ] = useState(false);
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ demand_no:  id, fin_year: localStorage.getItem('fin_year')})
	};
	const fetchData = async () => {
		const res = await fetch(APPROPRIATION_BY_DEMAND_URL,requestOptions);
		res
		  .json()
		  .then(res => setItems(res.DATA))
		  .catch(err => setErrors(err));
	};
	
	useEffect(() => {
		fetchData();
		setLoader(true);
	},[]);

	if(isLoaded === true){  
		return (
			<div>
				<NavbarComponent/> 
				<nav className="sticky">
					<Row>
						<Col className="col-5 offset-1">
							<Link to="/demand" title="Back to previous page">
								<h6 className="logout-icon">
									<MdArrowBack/>
									<span className='link'>Back to previous</span>
								</h6>
							</Link>
						</Col>
					</Row>
				</nav>
				<div className="App-common main">
					<Container>
						<Row>
							{items.map(item => 
								<Col className="col-sm-12 col-md-3 col-lg-3 mt-2" key={item.id}>
									<Link to={`/view/${item.link}`} >
									<Card border="secondary" className='custom-card'>
										<Card.Body>
											<Card.Title>
												<Row>
													<Col>
														{(item.appropriation_no==null)?'':item.appropriation_no+'-'} {item.description}
													</Col>
													<Col className="col-1">
														<span className="iconStyle">
															<img src="../images/pdf-icon.png" alt="pdf" width="20"/>
														</span>
													</Col>
												</Row>
											</Card.Title>
										</Card.Body>
									</Card>
									</Link>						
								</Col>)}	
						</Row>
					</Container> 
				</div>
				<FooterComponent/>
			</div>
		); 
	}
	else if(hasError === true){
		return (<div>
			<NavbarComponent/>
			<div className="App-common main">
				<Container className="centered">
					<Row>
						<Col className="col-1"></Col>
						<Col>Error <FaExclamationTriangle/> <h6>{hasError}.<br/>
						Refresh page to retry.</h6></Col>
					</Row>
				</Container>
			</div>
			<FooterComponent/>
		</div>)
	}
	if(items == null){
		return (<div>
			<NavbarComponent/>
			<div className="App-common main">
				<Container className="centered">
					<Row>
						<Col className="col-1"></Col>
						<Col><FaExclamationTriangle/> 
							<h6>No data available.<br/>
								Click <Link to="/main">here</Link> to go back.
							</h6>
						</Col>
					</Row>
				</Container>
			</div>
			<FooterComponent/>
		</div>)
	}
	else{
		return(<div class="simple-shape two"></div>)
	} 
}   
export default AppropriationComponent; 